import { render, staticRenderFns } from "./informacionPadre.vue?vue&type=template&id=36861c63"
import script from "./informacionPadre.vue?vue&type=script&lang=js"
export * from "./informacionPadre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports